// extracted by mini-css-extract-plugin
module.exports = {"menu":"FlowsListWrapper_menu__3nJ0c"};